import { supportConstants } from '../constants';
import { supportService } from '../services';
import { alertActions } from './alertActions';

export const supportActions = {
    getTicketsList,
    getTicketDetails,
    acceptTicket,
    addMessageTicket,
    closeTicket,
};

function getTicketPriority() {
    return dispatch => {
        dispatch(request(supportConstants.GET_TICKET_PRIORITY_REQUEST));
        supportService.getTicketPriority()
            .then(
                res => {
                    if (res === undefined) {
                        dispatch(alertActions.error('ارتباط با سرور برقرار نیست'));
                        dispatch(failure(supportConstants.GET_TICKET_PRIORITY_FAILURE, "ارتباط با سرور برقرار نیست"));
                    } else if (res.success) {
                        dispatch(success(supportConstants.GET_TICKET_PRIORITY_SUCCESS, res.data));
                    } else if (res.success === false) {
                        dispatch(alertActions.error(res.message));
                        dispatch(failure(supportConstants.GET_TICKET_PRIORITY_FAILURE, res.message));
                    }

                    setTimeout(() => {
                        dispatch(alertActions.clear());
                    }, 1500);
                },
                error => {
                    console.log("-----Error occurred-----");
                    console.log(error.toString());
                    dispatch(alertActions.error(error.toString()));
                    dispatch(failure(supportConstants.GET_TICKET_PRIORITY_FAILURE, error.toString()));
                }
            );
    };
}

function getTicketType() {
    return dispatch => {
        dispatch(request(supportConstants.GET_TICKET_TYPE_REQUEST));
        supportService.getTicketType()
            .then(
                res => {
                    if (res === undefined) {
                        dispatch(alertActions.error('ارتباط با سرور برقرار نیست'));
                        dispatch(failure(supportConstants.GET_TICKET_TYPE_FAILURE, "ارتباط با سرور برقرار نیست"));
                    } else if (res.success) {
                        dispatch(success(supportConstants.GET_TICKET_TYPE_SUCCESS, res.data));
                    } else if (res.success === false) {
                        dispatch(alertActions.error(res.message));
                        dispatch(failure(supportConstants.GET_TICKET_TYPE_FAILURE, res.message));
                    }

                    setTimeout(() => {
                        dispatch(alertActions.clear());
                    }, 1500);
                },
                error => {
                    console.log("-----Error occurred-----");
                    console.log(error.toString());
                    dispatch(alertActions.error(error.toString()));
                    dispatch(failure(supportConstants.GET_TICKET_TYPE_FAILURE, error.toString()));
                }
            );
    };
}


function addNewTicket(params) {
    return dispatch => {
        dispatch(request(supportConstants.ADD_NEW_TICKET_REQUEST));
        supportService.addNewTicket(params)
            .then(
                res => {
                    if (res === undefined) {
                        dispatch(alertActions.error('ارتباط با سرور برقرار نیست'));
                        dispatch(failure(supportConstants.ADD_NEW_TICKET_FAILURE, "ارتباط با سرور برقرار نیست"));
                    } else if (res.success) {
                        dispatch(alertActions.success(res.message));
                        dispatch(success(supportConstants.ADD_NEW_TICKET_SUCCESS, res.message));
                    } else if (res.success === false) {
                        dispatch(alertActions.error(res.message));
                        dispatch(failure(supportConstants.ADD_NEW_TICKET_FAILURE, res.message));
                    }

                    setTimeout(() => {
                        dispatch(alertActions.clear());
                    }, 1500);
                },
                error => {
                    console.log("-----Error occurred-----");
                    console.log(error.toString());
                    dispatch(alertActions.error(error.toString()));
                    dispatch(failure(supportConstants.ADD_NEW_TICKET_FAILURE, error.toString()));
                }
            );
    };
}


function getTicketsList(status) {
    return dispatch => {
        dispatch(request(supportConstants.GET_TICKETS_LIST_REQUEST));
        supportService.getTicketsList(status)
            .then(
                res => {
                    if (res === undefined) {
                        dispatch(alertActions.error('ارتباط با سرور برقرار نیست'));
                        dispatch(failure(supportConstants.GET_TICKETS_LIST_FAILURE, "ارتباط با سرور برقرار نیست"));
                    } else if (res.success) {
                        dispatch(success(supportConstants.GET_TICKETS_LIST_SUCCESS, res.data));
                    } else if (res.success === false) {
                        dispatch(alertActions.error(res.message));
                        dispatch(failure(supportConstants.GET_TICKETS_LIST_FAILURE, res.message));
                    }

                    setTimeout(() => {
                        dispatch(alertActions.clear());
                    }, 1500);
                },
                error => {
                    console.log("-----Error occurred-----");
                    console.log(error.toString());
                    dispatch(alertActions.error(error.toString()));
                    dispatch(failure(supportConstants.GET_TICKETS_LIST_FAILURE, error.toString()));
                }
            );
    };
}

function getTicketDetails(ticketId) {
    return dispatch => {
        dispatch(request(supportConstants.GET_TICKET_DETAILS_REQUEST));
        supportService.getTicketDetails(ticketId)
            .then(
                res => {
                    if (res === undefined) {
                        dispatch(alertActions.error('ارتباط با سرور برقرار نیست'));
                        dispatch(failure(supportConstants.GET_TICKET_DETAILS_FAILURE, "ارتباط با سرور برقرار نیست"));
                    } else if (res.success) {
                        dispatch(success(supportConstants.GET_TICKET_DETAILS_SUCCESS, res.data));
                        dispatch(success(supportConstants.UPDATE_TICKET_DETAILS_BY_ID, res.data));
                    } else if (res.success === false) {
                        dispatch(alertActions.error(res.message));
                        dispatch(failure(supportConstants.GET_TICKET_DETAILS_FAILURE, res.message));
                    }

                    setTimeout(() => {
                        dispatch(alertActions.clear());
                    }, 1500);
                },
                error => {
                    console.log("-----Error occurred-----");
                    console.log(error.toString());
                    dispatch(alertActions.error(error.toString()));
                    dispatch(failure(supportConstants.GET_TICKET_DETAILS_FAILURE, error.toString()));
                }
            );
    };
}


function acceptTicket(params, callBack) {
    return dispatch => {
        dispatch(request(supportConstants.ACCEPT_TICKET_REQUEST));
        supportService.acceptTicket(params)
            .then(
                res => {
                    if (res === undefined) {
                        dispatch(alertActions.error('ارتباط با سرور برقرار نیست'));
                        dispatch(failure(supportConstants.ACCEPT_TICKET_FAILURE, "ارتباط با سرور برقرار نیست"));
                    } else if (res.success) {
                        dispatch(success(supportConstants.ACCEPT_TICKET_SUCCESS, res.data));
                        dispatch(getTicketsList(1));
                        return callBack()
                    } else if (res.success === false) {
                        dispatch(alertActions.error(res.message));
                        dispatch(failure(supportConstants.ACCEPT_TICKET_FAILURE, res.message));
                    }

                    setTimeout(() => {
                        dispatch(alertActions.clear());
                    }, 1500);
                },
                error => {
                    console.log("-----Error occurred-----");
                    console.log(error.toString());
                    dispatch(alertActions.error(error.toString()));
                    dispatch(failure(supportConstants.ACCEPT_TICKET_FAILURE, error.toString()));
                }
            );
    };
}

function addMessageTicket(form) {
    return dispatch => {
        dispatch(request(supportConstants.ADD_MESSAGE_TICKET_REQUEST));
        supportService.addMessageTicket(form)
            .then(
                res => {
                    if (res === undefined) {
                        dispatch(alertActions.error('ارتباط با سرور برقرار نیست'));
                        dispatch(failure(supportConstants.ADD_MESSAGE_TICKET_FAILURE, "ارتباط با سرور برقرار نیست"));
                    } else if (res.success) {
                        dispatch(success(supportConstants.ADD_MESSAGE_TICKET_SUCCESS, res.data));
                        dispatch(getTicketDetails(res.data._id));
                    } else if (res.success === false) {
                        dispatch(alertActions.error(res.message));
                        dispatch(failure(supportConstants.ADD_MESSAGE_TICKET_FAILURE, res.message));
                    }

                    setTimeout(() => {
                        dispatch(alertActions.clear());
                    }, 1500);
                },
                error => {
                    console.log("-----Error occurred-----");
                    console.log(error.toString());
                    dispatch(alertActions.error(error.toString()));
                    dispatch(failure(supportConstants.ADD_MESSAGE_TICKET_FAILURE, error.toString()));
                }
            );
    };
}

function closeTicket(params, callBack) {
    return dispatch => {
        dispatch(request(supportConstants.CLOSE_TICKET_REQUEST));
        supportService.closeTicket(params)
            .then(
                res => {
                    if (res === undefined) {
                        dispatch(alertActions.error('ارتباط با سرور برقرار نیست'));
                        dispatch(failure(supportConstants.CLOSE_TICKET_FAILURE, "ارتباط با سرور برقرار نیست"));
                    } else if (res.success) {
                        dispatch(success(supportConstants.CLOSE_TICKET_SUCCESS, res.message));
                        dispatch(getTicketsList(2));
                        return callBack()
                    } else if (res.success === false) {
                        dispatch(alertActions.error(res.message));
                        dispatch(failure(supportConstants.CLOSE_TICKET_FAILURE, res.message));
                    }

                    setTimeout(() => {
                        dispatch(alertActions.clear());
                    }, 1500);
                },
                error => {
                    console.log("-----Error occurred-----");
                    console.log(error.toString());
                    dispatch(alertActions.error(error.toString()));
                    dispatch(failure(supportConstants.CLOSE_TICKET_FAILURE, error.toString()));
                }
            );
    };
}

const request = (type, data) => ({ type: type, data })

const success = (type, data) => ({ type: type, data })

const failure = (type, error) => ({ type: type, error })

